import React from "react";
import { Form } from "react-formio";
import { makeStyles } from "@mui/styles";
import { formioUploadOptions } from "../../utils/FileService";
import Lottie from "lottie-react";
import DataLoader from "../../animations/DataLoader.json";

const useStyles = makeStyles((theme) => ({
  formPreviewMainContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  loader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center !important",
    alignItems: "center !important",
  },
}));

function FormPreview({
  formData,
  loading,
  formRef,
  handleFormSubmit,
  selectedRow,
}) {
  // const dispatch = useDispatch();
  const classes = useStyles();

  return (
    <div className={classes.formPreviewMainContainer}>
      {loading ? (
        <div className={classes.loader}>
          <Lottie animationData={DataLoader} loop={true} />
        </div>
      ) : formData ? (
        <>
          <Form
            form={formData}
            ref={formRef}
            submission={{ data: selectedRow }}
            onSubmit={(submission) => handleFormSubmit(submission)}
            options={{ ...formioUploadOptions }}
          />
        </>
      ) : (
        <p>No form data available</p>
      )}
    </div>
  );
}

export default FormPreview;
